import SjQuestionFileItem from '../sj-question-file/src/SjQuestionFileItem.vue'

export default SjQuestionFileItem



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-file-item/index.js